import React, { useEffect, useState } from 'react'
import NotFoundMessage from 'components/NotFoundMessage'
import { useSelector } from "react-redux"
import classNames from "classnames"
import BackgroundCheckRow from './BackgroundCheckRow'
import styles from './styles'
import { Modal } from "../index"
import { getBackgroundCheck } from "../../services/apiKYP"
import ApplicantInfo from "../ApplicantInfo"
import LoadingComponent from "../LoadingComponent"
import ExpandableBackgroundCheck from "../ExpandedInfo/ExpandableBackgroundCheck"
import SectionedTitle from "../SectionedTitle"
import BackgroundCheckScoreSummary from "../ExpandedInfo/BackgroundCheckScoreSummary"
import BackgroundCheckPDFDownloadLink from "../Report/BackgroundCheckReport"


function BackgroundCheckTable(props) {
  const { backgroundChecks } = props

  const classes = styles()
  const [modal, setModal] = useState(false)
  const [clickedUUID, setClickedUUID] = useState(null)
  const [backgroundCheck, setBackgroundCheck] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const token = useSelector((state) => state.auth.access_token)

  const handleCloseModal = () => {
    setModal(false)
    setClickedUUID(null)
  }

  const handleOpenModal = (event) => {
    setClickedUUID(event.currentTarget.id)
  }

  const getBackgroundCheckData = () => {
    setLoading(true)
    getBackgroundCheck(token, clickedUUID).then((response) => {
      const { data } = response
      setBackgroundCheck(data)
      setError(false)
    }).catch(() => {
      setError(true)
      setBackgroundCheck(null)
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    if (clickedUUID) {
      getBackgroundCheckData()
      setModal(true)
    }
  }, [clickedUUID])

  return (
    <React.Fragment>
      {
        backgroundChecks?.length > 0 ? (
          <table className={classes.dataTable}>
            <thead>
            <tr>
              <th>Data de criação</th>
              <th style={{ minWidth: '200px' }}>Nome</th>
              <th style={{ minWidth: '80px' }}>CPF</th>
              <th
                className={classNames(classes.iconContent, classes.scoreHeaders)}
              >Data de nascimento
              </th>
              <th
                className={classNames(classes.iconContent, classes.scoreHeaders)}
              >Status
              </th>
              <th
                className={classNames(classes.iconContent, classes.scoreHeaders)}
              >Compliance list
              </th>
              <th
                className={classNames(classes.iconContent, classes.scoreHeaders)}
              >Região de risco
              </th>
              <th
                className={classNames(classes.iconContent, classes.scoreHeaders)}
              >Mídia negativa
              </th>
              <th
                className={classNames(classes.iconContent, classes.scoreHeaders)}
              >PEP
              </th>
              <th
                className={classNames(classes.iconContent, classes.scoreHeaders)}
              >Processos Judiciais
              </th>
              <th
                className={classNames(classes.iconContent, classes.scoreHeaders)}
              >Listas restritivas
              </th>
              < th
                className={classNames(classes.iconContent, classes.scoreHeaders)}
              >Pessoa vinculada
              </th>
              <th
                className={classNames(classes.iconContent, classes.scoreHeaders)}
              >Part. societária e ESG
              </th>
              <th
                className={classNames(classes.iconContent, classes.scoreHeaders)}
              >Score de crédito
              </th>
              <th
                className={classNames(classes.iconContent, classes.scoreHeaders)}
              >Pendências financeiras
              </th>
              <th>Score</th>
              <th>Detalhes</th>
            </tr>
            </thead>
            <tbody>
            {backgroundChecks?.map((bgc) => (
              <BackgroundCheckRow
                key={bgc.uuid}
                background_check={bgc}
                onClick={handleOpenModal}
              />
            ))}
            </tbody>
          </table>
        ) : (
          loading ? <div /> : (
            <div className={classes.noData}>
              <NotFoundMessage message='Nenhum registro encontrado' />
            </div>
          )
        )}
      {clickedUUID ? (
        <Modal
          open={modal}
          onClose={handleCloseModal}
          title="Background Check"
        >
          <div className={classes.root}>
            {loading ? (
                <LoadingComponent
                  loadingText='Carregando dados...'
                  layoutOrientation='vertical'
                  textColor="#000"
                  progressColor='#000'
                  progressSize={72}
                />
              ) :
              error ? (
                  <div className={classes.noData}>
                    <NotFoundMessage message='Não foi possível carregar os dados' />
                  </div>
                ) :
                (
                  <div className={classes.content}>
                    {backgroundCheck &&
                      <div className={classes.fixedHeader}>
                        <div className={classes.headerButtonRow}>
                          <div className={classes.leftHeaderButtonRow}>
                            <BackgroundCheckPDFDownloadLink backgroundCheck={backgroundCheck} />
                          </div>
                        </div>
                        <hr />
                      </div>
                    }
                    <section className={classes.firstSection}>
                      <SectionedTitle text='Dados pessoais' />
                      <ApplicantInfo
                        applicantData={backgroundCheck?.person}
                      />
                      <SectionedTitle text='Background Check' status={backgroundCheck?.status} />
                      <BackgroundCheckScoreSummary
                        scoreBoardData={backgroundCheck?.score_board}
                        status={backgroundCheck?.status}
                      />
                      <ExpandableBackgroundCheck backgroundCheck={backgroundCheck} />
                    </section>
                  </div>
                )
            }
          </div>
        </Modal>
      ) : null}
    </React.Fragment>
  )
}

export default BackgroundCheckTable
